import React from 'react';
import {Form} from 'react-final-form';
import {reduceFormValues} from "./utils/FormUtils";
const DcxFormContext = React.createContext({})

import arrayMutators from 'final-form-arrays'

export const READONLY = "%%READONLY";
export const AUTOCOMPLETE = "%%AUTOCOMPLETE";
export const VARIANT = "%%VARIANT";

const calculateStateDelta = (augFormName, commands) => {
    let delta = {augFormName}
    commands.forEach(command => {
        switch (command.type) {
            case AUTOCOMPLETE:
                delta.autoComplete = command.value;
                break;
            case READONLY:
                delta.readOnly = command.value;
                break;
            case VARIANT:
                delta.variant = command.value;
                break;
        }
    })
    return {formControlContext: delta}
}

const InnerForm = ({
        formControlContext,
        style,
        onSubmit,
        children,
        formKey,
        renderAction
    }) => {
    return (
        <Form
            key={formKey}
            onSubmit={onSubmit}
            onChange={(a,b,c) => {
                    debugger;
            }}
            destroyOnUnmount={false}
            enableReinitialize={true}
            keepDirtyOnReinitialize={true}
            updateUnregisteredFields={true}
            mutators={...arrayMutators}
            render={renderAction}
        />
    )
}


class DcxForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            formControlContext: {
                autoComplete: true,
                readOnly: false,
                variant: 'filled',
                augFormName: props.form
            }
        }
    }

    static getDerivedStateFromProps(props, state) {
        const {formControlContext} = state;
        if (props.command) {
            return calculateStateDelta(formControlContext.augFormName, [props.command])
        }
        if (props.commands) {
            return calculateStateDelta(formControlContext.augFormName, props.commands)
        }
        return null;
    }

    submitter(onSubmit, formValues) {
        const {formControlContext} = this.state;
        //sometimes this is called when no onSubmit has been provided to DcxForm (USER_ACTIONS_FORM) as the submission is likely to be handled otherwise
        if(onSubmit) {
        debugger;
            const reducedFormValues = reduceFormValues(formControlContext.augFormName, formValues)
            onSubmit(reducedFormValues);
        }
    }

    renderForm(formControlContext, props, children) {
        const {initialValues, onSubmit, renderAction, formKey, ...rest} = props;
        /*let scopedInitialValues = {}
        Object.keys(initialValues || {}).forEach(key => {
            scopedInitialValues[`${formControlContext.augFormName}#${key}`] = initialValues[key];
        })*/

        return (
            <>
                <InnerForm
                    formKey={formKey}
                    formControlContext={formControlContext}
                    initialValues={initialValues}
                    onSubmit={this.submitter.bind(this, onSubmit)}
                    renderAction={renderAction}
                    {...rest}
                >
                {children}
                </InnerForm>
            </>
        )
    }

    render() {
        const {children, nestedForm} = this.props;
        const {formControlContext} = this.state;
        return (
            <DcxFormContext.Provider value={{formControlContext}}>
                {!nestedForm ? this.renderForm(formControlContext, this.props, children) : (
                    <React.Fragment>
                        {children}
                    </React.Fragment>
                )}
            </DcxFormContext.Provider>
        )
    }
}

export default (DcxForm)

export const withDcxFormContext = (Component) => {
    return (props) => {
        return (
            <DcxFormContext.Consumer>
                {({formControlContext}) => (
                    <Component
                        {...props}
                        formControlContext={formControlContext}
                    />
                )}
            </DcxFormContext.Consumer>
        )
    }
}